<template>
    <div
        class="size-full flex justify-center items-center bg-gray-200 group cursor-pointer"
    >
        <suspense>
            <InsertModal
                :table="params.table"
                :type="'edit'"
                :edit-item="editItem"
            />
        </suspense>
    </div>
</template>

<script lang="ts" setup>
import type { ICellRendererParams } from "ag-grid-community"

const { params } = defineProps<{
    params: ICellRendererParams & { table: string; type?: string }
}>()

const editItem = computed(() => {
    if (params.table === "jevposkytovatel_mn") {
        return {
            ID: params.data.ID,
            RELEVANCE: params.data.RELEVANCE,
            POSKYTOVATELID: params.data.POSKYTOVATELID,
            JEVKOD: params.data.JEVKOD,
        }
    }
    return params.data
})
</script>

<style scoped></style>
